import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CreateNotificationProps,
  NotificationFilter,
  UpdateNotificationProps,
} from 'modules/core/domain/interfaces/supabase/notifications/types';
import supabase from 'modules/core/supabase/supabase';

export const fetchNotifications = createAsyncThunk('notifications/fetchNotifications', async (filter: NotificationFilter) => {
  const { type, sort, limit, offset, userId } = filter;
  const apiFilter: NotificationFilter = {
    limit,
    offset,
    type: type === 'all' ? undefined : type,
    sort: sort === 'asc' ? 'asc' : 'desc',
    userId,
  };
  const { data, count } = await supabase.notifications.getNotifications(apiFilter);
  return { notifications: data, total: count };
});

export const fetchNotificationById = createAsyncThunk('notifications/fetchNotificationById', async (id: number) => {
  const notification = await supabase.notifications.getNotificationById(id);
  return notification;
});

export const createNotification = createAsyncThunk('notifications/createNotification', async (props: CreateNotificationProps) => {
  const notification = await supabase.notifications.createNotification(props);
  return notification;
});

export const updateNotification = createAsyncThunk('notifications/updateNotification', async (props: UpdateNotificationProps) => {
  const notification = await supabase.notifications.updateNotification(props);
  return notification;
});

export const deleteNotification = createAsyncThunk('notifications/deleteNotification', async (id: number) => {
  await supabase.notifications.deleteNotification(id);
  return id;
});
